import telegramMessage from '@/api/notification/telegram-message'
import moment from 'moment'
import { join } from 'lodash'

export const state = {
  formModels: { shops: [], drivers: [] },
  loading: false,
  histories: { data: [], meta: {} },
  pagination: { currentPage: 1, lastPage: 0, perPage: 15, total: 0 },
  search: null,
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const mutations = {
  SET_FORM_MODELS (state, data) { state.formModels = data },
  SET_LOADING (state, value) { state.loading = value },
  SET_HISTORY (state, data) {
    state.histories = data
    const meta = data.meta || {}
    state.pagination = {
      currentPage: meta.current_page || 1,
      lastPage: meta.last_page || 0,
      perPage: meta.per_page || 15,
      total: meta.total || 0
    }
  },
  SET_SEARCH (state, value) { state.search = value === '' ? null : value },
  SET_DATE_RANGE (state, value) { state.dateRange = value },
  SET_PAGE (state, value) { state.pagination.currentPage = value }
}

export const actions = {
  async getFormModels ({ commit }) {
    const response = await telegramMessage.formModel()
    commit('SET_FORM_MODELS', response)
    return response
  },
  fetchHistory ({ commit, state }, options = {}) {
    const params = Object.assign({
      perPage: 15,
      filter: {
        search: state.search,
        date_between: join(state.dateRange, ',')
      }
    }, options.params || {})
    return telegramMessage.history(Object.assign({}, options, { params })).then(response => {
      commit('SET_HISTORY', response)
      return response
    })
  },
  findDraft ({ commit }, id) {
    commit('SET_LOADING', true)
    return telegramMessage.find(id).finally(() => commit('SET_LOADING', false))
  },
  findDetail ({ commit }, { id, params } = {}) {
    commit('SET_LOADING', true)
    return telegramMessage.detail(id, { params }).finally(() => commit('SET_LOADING', false))
  },
  send ({ commit }, data) {
    commit('SET_LOADING', true)
    return telegramMessage.send(data).finally(() => commit('SET_LOADING', false))
  },
  updateDraft ({ commit }, { id, data }) {
    commit('SET_LOADING', true)
    return telegramMessage.update(id, data).finally(() => commit('SET_LOADING', false))
  },
  deleteMessage ({ commit }, id) {
    commit('SET_LOADING', true)
    return telegramMessage.destroy(id).finally(() => commit('SET_LOADING', false))
  }
}
